/**
 * Created by don on 9/15/15.
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var SoaCollection = require('bunsen/collections/SoaCollection');
var Period = require('bunsen/models/Period');
var Category = require('bunsen/models/inventory/Category');
var AuthorizedRole = require('bunsen/models/identity/AuthorizedRole');
var DoubleWrapper = SoaModel.extend({});
var BooleanWrapper = SoaModel.extend({});
var StringWrapper = SoaModel.extend({});
var PublicationAttributeValues;

var TransformModel = SoaModel.extend({

    constructor: function (attrs, options) {
        switch (attrs.apiType) {
            case 'adminRole':
            case 'userRole':
                return new AuthorizedRole(attrs, options);
            case 'doubleWrapper':
                return new DoubleWrapper(attrs, options);
            case 'period':
                return new Period(attrs, options);
            case 'booleanWrapper':
                return new BooleanWrapper(attrs, options);
            case 'stringWrapper':
                return new StringWrapper(attrs, options);
            case 'category':
                return new Category(attrs, options);

        }
    }

});

PublicationAttributeValues = SoaCollection.extend({

    model: TransformModel

});

// expose models unique to this collection
PublicationAttributeValues.DoubleWrapper = DoubleWrapper;
PublicationAttributeValues.BooleanWrapper = BooleanWrapper;

module.exports = PublicationAttributeValues;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/PublicationAttributeValues.js
// module id = 2626
// module chunks = 63